export enum TaskPriority {
  low = 'Low',
  standard = 'Standard',
  high = 'High',
}
